import { render, staticRenderFns } from "./BarrelStatusHistoryRecord.vue?vue&type=template&id=a8367bea&scoped=true&"
import script from "./BarrelStatusHistoryRecord.vue?vue&type=script&lang=ts&"
export * from "./BarrelStatusHistoryRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8367bea",
  null
  
)

export default component.exports